<template>
  <admin-user />
</template>
<script>
import AdminUser from '@/components/admin/user/index.vue'
export default {
  components: { AdminUser }
}
</script>
